import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import CircleStyle from "ol/style/Circle";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Draw, Snap, Modify } from "ol/interaction";
import { Feature } from "ol";
import { addFeature } from "../../../store/slices/drawSlice";
import {
  DRAW_DRAWING_FEATURE_COLOR,
  DRAW_DRAWING_FEATURE_STROKE_COLOR,
  DRAW_DRAWING_FEATURE_STROKE_WIDTH,
  DRAW_FEATURE_COLOR,
  DRAW_FEATURE_KEY,
  DRAW_FEATURE_STROKE_COLOR,
  DRAW_FEATURE_STROKE_WIDTH,
  DRAW_LAYER_ID,
} from "../consts";
import type { Dispatch, UnknownAction } from "redux";
import { toLonLat } from "ol/proj";
import type { Coordinate, DrawFeature, DrawGeometry, DrawingMode } from "../types";

export function createOLDrawing(
  map: any,
  mode: DrawingMode,
  editingFeatureId: string | null,
  features: DrawFeature[],
  dispatch: Dispatch<UnknownAction> | any,
) {
  let draw: any; // ol Draw
  let snap: any; // ol Snap
  //let modify: any; // ol Modify

 

  const style = new Style({
    fill: new Fill({
      color: DRAW_DRAWING_FEATURE_COLOR,
    }),
    stroke: new Stroke({
      color: DRAW_DRAWING_FEATURE_STROKE_COLOR,
      lineDash: [10, 10],
      width: DRAW_DRAWING_FEATURE_STROKE_WIDTH,
    }),
    image: new CircleStyle({
      radius: 5,
      stroke: new Stroke({
        color: DRAW_DRAWING_FEATURE_STROKE_COLOR,
        width: DRAW_DRAWING_FEATURE_STROKE_WIDTH,
      }),
      fill: new Fill({
        color: DRAW_DRAWING_FEATURE_COLOR,
      }),
    }),
  });
  return {
    activate() {
      if (mode === "NONE") return;
      const source = new VectorSource();
      const layer = new VectorLayer({ source });
      layer.set("id", DRAW_LAYER_ID);

      map.addLayer(layer);
      const snap = new Snap({ source: source });
      //const modify = new Modify({ source: source });
      draw = new Draw({
        source: source,
        type: mode === "POINT" ? "Point" : mode === "LINESTRING" ? "LineString" : "Polygon",
        style: style,
      });
      draw.on("drawend", (evt: { feature: Feature }) => {
        evt?.feature.setStyle(
          new Style({
            fill: new Fill({ color: DRAW_FEATURE_COLOR }),
            stroke: new Stroke({ color: DRAW_FEATURE_STROKE_COLOR, width: DRAW_FEATURE_STROKE_WIDTH }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({ color: DRAW_FEATURE_COLOR }),
              stroke: new Stroke({ color: DRAW_FEATURE_STROKE_COLOR, width: DRAW_FEATURE_STROKE_WIDTH }),
            }),
          }),
        );

        const geom = (evt.feature as { getGeometry: () => unknown }).getGeometry();
        const newGeom = olGeomToDraw(geom, toLonLat);
        if (newGeom) {
          dispatch(
            addFeature({
              id: evt?.feature?.getId()?.toString() || evt?.feature?.get("id") || `${DRAW_FEATURE_KEY}-${crypto.randomUUID()}`,
              geometry: newGeom,
            }),
          );
        }
      });
      map.addInteraction(draw);
      map.addInteraction(snap);
      //map.addInteraction(modify);
    },

    deactivate() {
      if (draw) {
        map.removeInteraction(draw);
        map.removeInteraction(snap);
        //map.removeInteraction(modify);
      }
    },
  };
}

export function olGeomToDraw(geom: unknown, toLonLat: (c: number[]) => number[]): DrawGeometry | null {
  const type = (geom as { getType: () => string }).getType();
  if (type === "Point") {
    const [lng, lat] = toLonLat((geom as { getCoordinates: () => number[] }).getCoordinates());
    return { type: "Point", coordinates: [lng, lat] as Coordinate };
  } else if (type === "LineString") {
    return { type: "LineString", coordinates: (geom as { getCoordinates: () => number[][] }).getCoordinates().map((c) => toLonLat(c) as Coordinate) };
  } else if (type === "Polygon") {
    return {
      type: "Polygon",
      coordinates: (geom as { getCoordinates: () => number[][][] }).getCoordinates().map((r) => r.map((c) => toLonLat(c) as Coordinate)),
    };
  }
  return null;
}
